export const EXTERNAL_LINKS = Object.freeze({
  LINKEDIN: "https://www.linkedin.com/in/andyh031/",
  EMAIL: "andy45.hu@gmail.com",
  GITHUB: "https://github.com/andyh031",
});

export const WEBSITE_PATHS = Object.freeze({
  HOME: "/",
  PROJECTS: "/projects",
  EXPERIENCE: "/experience",
});

export const SECTION_BG_COLOUR = Object.freeze({
  HOME: "#f4f9fc",
  PROJECTS: "#fff7f7",
  EXPERIENCE: "#f6fcf4",
});

export const PROJECT_LINKS = Object.freeze({
  PANTRYPLANNER: "https://devpost.com/software/pantry-planner-l81gm3",
  PINMASTER: "https://devpost.com/software/pinmaster3",
  FOODER: "https://devpost.com/software/fooder-hsc4fp",
  SUBLETTER: "https://github.com/andyh031/subletter",
  SORTAPP: "https://github.com/andyh031/sort-app",
  HEART: "https://github.com/andyh031/heart-disease-classification",
  GRADEAIR: "https://github.com/andyh031/grade-air",
});
